import(/* webpackMode: "eager" */ "/vercel/path0/src/app/a-propos/page.tsx");
